module.exports = __webpack_public_path__ + "assets/caomei.ee1a96e2.svg";